// services
import db from '@/services/db'

import { swfRelease } from '@/components/Dashboard/hooks/helpers/simple-workflow'

export default {
  simpleWorkflow_read({ commit, state }, cb) {
    db.simpleWorkflow.read((workflows) => {
      // release event handlers to don't duplicate events
      swfRelease(state.simpleWorkflows)

      commit('simpleWorkflow_set', workflows)

      if (cb) cb(workflows)
    })
  },
}
